import { Consent } from '../../types';
import { atomWithBroadcast } from '../core/atomWithBroadcast';

export const consentsAtom = atomWithBroadcast<Array<Consent>>('core/consents', []);
